import sheetPrintModal from "@/views/menu/sheet/operation/sheetPrintModal.vue";

export default {
    mixins: [],
    components: {
        sheetPrintModal
    },
    props: {},
    data () {
        return {
            showPrintModal: false
        };
    },
    computed: {
        printObj () {
            // 打印内容配置
            return {
                id: "sheetUpdatePrintContent",
                popTitle: this.modName
            };
        }
    },
    methods: {
        // 打印弹框开/关
        openPrintModal () {
            this.dshRenderName = "sheetPrintModalRender";
            this.showPrintModal = true;
        },
        // 关闭预览打印
        // cancelShowtPrintModal () {
        //     this.dshRenderName = undefined;
        //     this.showPrintModal = false;
        // },
        // 切换模态框
        toggleApproveModal (bool) {
            this.showPrintModal = bool;
        },
        sheetPrintModalRender (h, params) {
            return this.showPrintModal
                ? h("sheet-print-modal", {
                    props: {
                        value: this.showPrintModal,
                        formData: this.formData,
                        curScreenFormList: this.curScreenFormList,
                        showPrintModalPropsObj: this.showPrintModalPropsObj,
                        printObj: this.printObj
                    },
                    on: {
                        input: this.toggleApproveModal
                    }
                })
                : undefined;
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/menu/sheet/operation/sheetPrintModalRenderMixin.js